import { useEffect, useState } from 'react';
import { Antenna, RadioTower } from 'lucide-react';
import { resolveEquipmentImage, type EquipmentImageKind } from './equipment-image-manifest';

export interface EquipmentImageItem {
  sku: string | null;
  model: string;
}

export function EquipmentProductImage({ kind, item, className = '', loading = 'lazy' }: {
  kind: EquipmentImageKind;
  item: EquipmentImageItem | null;
  className?: string;
  loading?: 'eager' | 'lazy';
}): React.JSX.Element {
  const source = item ? resolveEquipmentImage(kind, item) : null;
  const [failedSource, setFailedSource] = useState<string | null>(null);
  const unavailable = source === null || source === failedSource;
  const FallbackIcon = kind === 'radio' ? RadioTower : Antenna;

  useEffect(() => setFailedSource(null), [source]);

  return <span className={`equipment-product-image ${className}`.trim()} data-equipment-kind={kind} data-image-state={unavailable ? 'fallback' : 'ready'} aria-hidden="true">
    {unavailable
      ? <FallbackIcon className="equipment-product-fallback" />
      : <img src={source} alt="" loading={loading} decoding="async" draggable={false} referrerPolicy="no-referrer" onError={() => setFailedSource(source)} />}
  </span>;
}
